import StoryCollections from './components/FilterPage/Tabs/StoryCollections/StoryCollections.vue'
import PlaylistsCollections from './components/FilterPage/Tabs/PlaylistsCollections.vue'
import ToursCollections from './components/FilterPage/Tabs/ToursCollections/ToursCollections.vue'
import { createRouter, createWebHistory } from 'vue-router'
import { getRoutes } from './helpers/helpers';

const { storiesRoute, playlistsRoute, toursRoute } = getRoutes("vue-filter-page-component");

function normalizeRoute(route) {
    return route.startsWith("/") ? route : `/${route}`;
}

const routes = [
    {
        path: `${normalizeRoute(storiesRoute)}/:story?`,
        component: StoryCollections,
    },
    {
        path: `${normalizeRoute(playlistsRoute)}`,
        component: PlaylistsCollections,
    },
    {
        path: `${normalizeRoute(toursRoute)}`,
        component: ToursCollections,
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes,
})

// replacing active nav class in header during vue routing
router.beforeEach((to, from, next) => {
    document.querySelector(`#main-header .dropdown-menu a[href="${from.path}/"]`)?.classList?.remove('active')

    document.querySelector(`#main-header .dropdown-menu a[href="${to.path}/"]`)?.classList?.add('active')

    next()
})

export  { router }
